import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_v7zu4dmfwd: FaireCollectionEntity = {
  token: "pbc_v7zu4dmfwd",
  type: "collection",
  name: "Milan Classic Sweater Knit Baby Collection (SS26)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f92660808669b770f15b2757cef7f33771d8f78e63415638cfda8445e157c364.jpeg",
  itemCount: 28,
  description:
    "Our original and best-loved sweater knit baby collection, the Milan Classic features timeless silhouettes crafted from certified organic cotton. Designed for everyday comfort and easy layering, this foundational collection is offered in six versatile colors and remains a customer",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:16.525Z",
    importedBy: "entity-db-import-collections",
  },
};
